export const INVOICE_STATUS_MISSING_MERCHANT = 'MissingMerchant';
export const INVOICE_STATUS_PENDING_PAYMENT = 'PendingPayment';
export const INVOICE_STATUS_PARTIALLY_PAID = 'PartiallyPaid';
export const INVOICE_STATUS_PAID = 'Paid';
export const INVOICE_STATUS_CANCELLED = 'Cancelled';
export const INVOICE_STATUS_NEED_MANUAL_ATTENTION = 'NeedsManualAttention';

export const INVOICE_TYPE_LEASE = 'lease';
export const INVOICE_TYPE_SUNSETUP_LEASE = 'sunsetupLease';
export const INVOICE_TYPE_RENEWAL = 'renewal';
export const INVOICE_TYPE_WITHDRAWAL_FEE = 'withdrawalFee';
export const INVOICE_TYPE_FAILED_SETUP = 'failedSetup';
export const INVOICE_TYPE_3D_TOUR = '3dTour';
export const INVOICE_TYPE_SUNLOCK_SALES = 'sunlockSales';

export const INVOICE_TYPES = [
  INVOICE_TYPE_LEASE,
  INVOICE_TYPE_SUNSETUP_LEASE,
  INVOICE_TYPE_RENEWAL,
  INVOICE_TYPE_WITHDRAWAL_FEE,
  INVOICE_TYPE_FAILED_SETUP,
  INVOICE_TYPE_3D_TOUR,
  INVOICE_TYPE_SUNLOCK_SALES,
];

export const INVOICE_TYPE_ORDER = INVOICE_TYPES.reduce(
  (memo, type) => ({
    ...memo,
    [type]: INVOICE_TYPES.indexOf(type),
  }),
  {},
);

export const INVOICE_TYPE_SUNLOCK_SALES_FLAT_RATE = 250;

export const INVOICE_STATUS_LIST = [
  INVOICE_STATUS_MISSING_MERCHANT,
  INVOICE_STATUS_PENDING_PAYMENT,
  INVOICE_STATUS_PARTIALLY_PAID,
  INVOICE_STATUS_PAID,
  INVOICE_STATUS_CANCELLED,
  INVOICE_STATUS_NEED_MANUAL_ATTENTION,
];

export const INVOICE_STATUS_LIST_CANCELLABLE = [
  INVOICE_STATUS_MISSING_MERCHANT,
  INVOICE_STATUS_PENDING_PAYMENT,
  INVOICE_STATUS_NEED_MANUAL_ATTENTION,
];

export const INVOICE_SCHEDULE_UNITARY = 'unitary';
export const INVOICE_SCHEDULE_MONTHLY = 'monthly';

export const INVOICE_SCHEDULE_TYPES = [INVOICE_SCHEDULE_UNITARY, INVOICE_SCHEDULE_MONTHLY];

export const DISCOUNT_STATUS_ACTIVE = 'active';
export const DISCOUNT_STATUS_APPLIED = 'applied';
export const DISCOUNT_STATUS_CANCELLED = 'cancelled';

export const DISCOUNT_TYPE_PARTNER = 'partner';
export const DISCOUNT_TYPE_LISTING = 'listing';

export const DISCOUNT_TYPES = [DISCOUNT_TYPE_PARTNER, DISCOUNT_TYPE_LISTING];

export const COMMISSION_TYPE_FLAT_RATE = 'FlatRate';
export const COMMISSION_TYPE_PERCENTAGE = 'Percentage';

export const LOCATOR_COMMISSION_STATUS_NOT_PAID = 'NotPaid';
export const LOCATOR_COMMISSION_STATUS_PAID = 'Paid';
export const LOCATOR_COMMISSION_STATUS_CANCELLED = 'Cancelled';

export const LEASE_TYPE_MLS = 'MLS';
export const LEASE_TYPE_APARTMENT = 'Apartment';

export const LEASE_STATUS_DRAFT = 'Draft';
export const LEASE_STATUS_SIGNED = 'Signed';
export const LEASE_STATUS_MOVED_IN = 'MovedIn';
export const LEASE_STATUS_CANCELLED = 'Cancelled';

export const LEASE_TEMPLATE_TYPE_STANDARD = 'TarStandard';
export const LEASE_TEMPLATE_TYPE_CUSTOM_LEASE = 'CustomLease';

export const PAYMENT_RECEIVED_TYPE_CHECK = 'Check';
export const PAYMENT_RECEIVED_TYPE_ACH = 'ACH';
export const PAYMENT_RECEIVED_TYPE_EARTH_CLASS = 'EarthClass';
export const PAYMENT_RECEIVED_TYPE_ROUTABLE = 'Routable';

export const PAYMENT_METHOD_CASHIER_CHECK = 'CashierCheck';
export const PAYMENT_METHOD_ELECTRONIC_PAYMENT = 'ElectronicPayment';
export const PAYMENT_METHOD_MONEY_ORDER = 'MoneyOrder';
export const PAYMENT_METHOD_PERSONAL_CHECK = 'PersonalCheck';
export const PAYMENT_METHOD_OTHER = 'Other';

export const ACCOUNT_TYPE_CREDIT_DEBIT_CARD = 'CreditDebitCard';
export const ACCOUNT_TYPE_BANK = 'BankAccount';

export const PAYMENT_RECEIVED_TYPE_OPTION_ITEMS = [
  {
    label: PAYMENT_RECEIVED_TYPE_CHECK,
    value: PAYMENT_RECEIVED_TYPE_CHECK,
  },
  {
    label: PAYMENT_RECEIVED_TYPE_ACH,
    value: PAYMENT_RECEIVED_TYPE_ACH,
  },
  {
    label: PAYMENT_RECEIVED_TYPE_EARTH_CLASS,
    value: PAYMENT_RECEIVED_TYPE_EARTH_CLASS,
  },
];

export const DISCOUNT_APPLY_GLOBAL = 'global';
